// FILE: src/utils/firebase/features/accounts/fetchers.js

import { COLLECTIONS } from "../../core/collections";
import * as emailScoped from "../../core/emailScoped";
import { getOrFetch, getOrFetchWithMeta, invalidate as _invalidate } from "../../cache/getOrFetch";

/* ---------- TTLs ---------- */
const TTL_ACCOUNTS = Number(process.env.REACT_APP_TTL_ACCOUNTS_MS) || 60 * 60 * 1000; // 1h

export function subscribeUserAccounts({ userEmail, cap, onData, onError }) {
  return emailScoped.subscribeByEmailHelper({
    colName: COLLECTIONS.userAccounts,
    userEmail,
    cap,
    extra: [],
    onData,
    onError,
  });
}

export function fetchUserAccountsOnce(userEmail, opts = {}) {
  if (opts?.noCache) {
    return emailScoped.fetchByEmailOnce(COLLECTIONS.userAccounts, userEmail, opts);
  }
  const key = `accounts:${userEmail}`;
  return getOrFetch({
    key,
    ttlMs: opts.ttlMs ?? TTL_ACCOUNTS,
    persist: true,
    persistKey: key,
    fetcher: () => emailScoped.fetchByEmailOnce(COLLECTIONS.userAccounts, userEmail, opts),
  });
}

/* New: meta variant for pill */
export async function fetchUserAccountsOnceWithMeta(userEmail, opts = {}) {
  if (opts?.noCache) {
    const value = await emailScoped.fetchByEmailOnce(COLLECTIONS.userAccounts, userEmail, opts);
    return { value, fromCache: false };
  }
  const key = `accounts:${userEmail}`;
  return getOrFetchWithMeta({
    key,
    ttlMs: opts.ttlMs ?? TTL_ACCOUNTS,
    persist: true,
    persistKey: key,
    fetcher: () => emailScoped.fetchByEmailOnce(COLLECTIONS.userAccounts, userEmail, opts),
  });
}

/* ---------- Cache Invalidator ---------- */
export function invalidateAccountsCache(userEmail) {
  _invalidate(`accounts:${userEmail}`);
}
